var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurkmenistan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 0C11.1035 0 10.2308 0.0990469 9.39086 0.285234L8.86914 12L9.39086 23.7147C10.2308 23.9009 11.1036 24 11.9995 24C18.6269 24 23.9995 18.6274 23.9995 12C23.9995 5.37258 18.6269 0 11.9995 0V0Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13041 3.91736C1.18584 6.04998 0 8.88639 0 11.9999C0 15.1135 1.18589 17.9499 3.13045 20.0826L3.65217 11.9999L3.13041 3.91736Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5512 9.05143C18.1416 7.40584 17.4783 5.61611 16.0548 4.72473C16.3109 4.75806 16.5672 4.81834 16.8201 4.90904C18.7187 5.59023 19.7056 7.68142 19.0244 9.57995C18.3432 11.4786 16.252 12.4654 14.3535 11.7842C14.1005 11.6935 13.8643 11.577 13.6455 11.44C15.311 11.6569 16.9608 10.697 17.5512 9.05143Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2766 4.27368L13.7636 4.93659L12.9747 4.65351L13.4465 5.34623L12.9336 6.00904L13.7382 5.77438L14.2101 6.46701L14.2355 5.62926L15.0401 5.39456L14.2513 5.11157L14.2766 4.27368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6614 6.43359L15.1484 7.09645L14.3595 6.81338L14.8314 7.50609L14.3184 8.16891L15.123 7.93416L15.5949 8.62692L15.6203 7.78912L16.4249 7.55438L15.636 7.27134L15.6614 6.43359Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8342 5.0603L11.3212 5.72312L10.5323 5.44013L11.0042 6.1328L10.4912 6.79566L11.2958 6.56096L11.7677 7.25363L11.7931 6.41588L12.5977 6.18118L11.8089 5.8981L11.8342 5.0603Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7776 7.53455L11.2646 8.19741L10.4757 7.91437L10.9477 8.60709L10.4346 9.26991L11.2393 9.03525L11.7112 9.72787L11.7365 8.89012L12.5412 8.65542L11.7522 8.37234L11.7776 7.53455Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1321 8.37927L13.6191 9.04208L12.8302 8.75905L13.3022 9.45177L12.7891 10.1145L13.5938 9.87988L14.0657 10.5726L14.091 9.73476L14.8957 9.5001L14.1067 9.21707L14.1321 8.37927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13086 3.91743V20.0826C4.76586 21.8758 6.93758 23.1707 9.39172 23.7147V0.285278C6.93753 0.82931 4.76591 2.12423 3.13086 3.91743Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51985 6.3181L4.47168 5.53725V4.43302L5.51985 3.65222H7.00227L8.05045 4.43302V5.53725L7.00227 6.3181H5.51985Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26109 3.65222H5.51985L4.47168 4.43302V4.97288H6.26109V3.65222Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26074 6.31814H7.00193L8.0501 5.5373V4.974H6.26074V6.31814Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51985 20.3478L4.47168 19.5669V18.4627L5.51985 17.6819H7.00227L8.05045 18.4627V19.5669L7.00227 20.3478H5.51985Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26109 17.6819H5.51985L4.47168 18.4627V19.0026H6.26109V17.6819Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26074 20.3478H7.00193L8.0501 19.5669V19.0037H6.26074V20.3478Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51985 13.3329L4.47168 12.552V11.4478L5.51985 10.667H7.00227L8.05045 11.4478V12.552L7.00227 13.3329H5.51985Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0867 15.0508H7.63013V14.5943H6.82787L6.26059 14.027L5.69335 14.5943H4.89109V15.0508H4.43457V15.9638H4.89109V16.4203H5.6933L6.26063 16.9876L6.82787 16.4203H7.63013V15.9638H8.0867V15.0508Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0867 8.03593H7.63013V7.57937H6.82787L6.26059 7.01208L5.69335 7.57937H4.89109V8.03593H4.43457V8.94896H4.89109V9.40548H5.6933L6.26063 9.97285L6.82787 9.40548H7.63013V8.94896H8.0867V8.03593Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73926 11.4781H6.78274V12.5216H5.73926V11.4781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26098 9.01402C6.54911 9.01402 6.7827 8.78044 6.7827 8.4923C6.7827 8.20416 6.54911 7.97058 6.26098 7.97058C5.97284 7.97058 5.73926 8.20416 5.73926 8.4923C5.73926 8.78044 5.97284 9.01402 6.26098 9.01402Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26098 16.0293C6.54911 16.0293 6.7827 15.7957 6.7827 15.5076C6.7827 15.2194 6.54911 14.9858 6.26098 14.9858C5.97284 14.9858 5.73926 15.2194 5.73926 15.5076C5.73926 15.7957 5.97284 16.0293 6.26098 16.0293Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/b831a15d.svg";
export { SvgTurkmenistan as ReactComponent };